import { InfiniteData } from '@tanstack/react-query';
import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type.ts';
import { VehicleSystemType } from '@/common/queries/selections/vehicleSystem/vehicleSystem.type';

export const vehicleSystemSelectFunction = (
  data: InfiniteData<PaginationResponseType<VehicleSystemType[]>, number>,
) => {
  return {
    ...data,
    pages: data.pages.map((page) => {
      return {
        ...page,
        results: page.results,
      };
    }),
  };
};

export type MyFilesListDataType = ReturnType<
  typeof vehicleSystemSelectFunction
>;
